import { render, staticRenderFns } from "./permSave.vue?vue&type=template&id=9cd620a6"
import script from "./permSave.vue?vue&type=script&lang=js"
export * from "./permSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports